<template>
  <div id="changePassword">
    <el-row
      type="flex"
      justify="center"
    >
      <el-col
        :md="20"
        :lg="18"
        :xl="16"
      >
        <el-form
          ref="changePasswordForm"
          :model="rigisterData"
          label-width="80px"
          :rules="rigisterRules"
        >
          <el-form-item
            label="舊密碼"
            prop="oldPassword"
          >
            <el-input
              v-model="rigisterData.oldPassword"
              type="password"
              class="rigisterInput"
              maxlength="6"
              placeholder="請輸入舊密碼"
              autocomplete="off"
              show-password
              @input="filterValidValue('oldPassword')"
            />
          </el-form-item>
          <el-form-item
            label="新密碼"
            prop="password"
          >
            <el-input
              v-model="rigisterData.password"
              type="password"
              class="rigisterInput"
              maxlength="6"
              placeholder="請輸入6位數字密碼"
              autocomplete="off"
              show-password
              @input="filterValidValue('password')"
            />
          </el-form-item>
          <el-form-item
            label="確認密碼"
            prop="password2"
          >
            <el-input
              v-model="rigisterData.password2"
              type="password"
              class="rigisterInput"
              maxlength="6"
              placeholder="請再一次輸入密碼"
              show-password
              @input="filterValidValue('password2')"
            />
          </el-form-item>
          <el-row
            type="flex"
            justify="center"
          >
            <el-button
              round
              @click="$toMainPage()"
            >
              取消
            </el-button>
            <el-button
              type="primary"
              round
              @click="sendRigistration()"
            >
              確定
            </el-button>
          </el-row>
        </el-form>
      </el-col>
    </el-row>
  </div>
</template>
<script>
export default {
  data () {
    const checkForm = (rule, value, callback) => {
      const passwordRegex = /^\d{6}$/
      switch (rule.field) {
        case 'oldPassword':
          if (!value) {
            return callback(new Error('舊密碼不可為空'))
          } else if (!passwordRegex.test(value)) {
            return callback(new Error('密碼格式錯誤，請輸入6位數字'))
          } else {
            callback()
          }
          break
        case 'password':
          if (!value) {
            return callback(new Error('新密碼不可為空'))
          } else if (!passwordRegex.test(value)) {
            return callback(new Error('密碼格式錯誤，請輸入6位數字'))
          } else {
            callback()
          }
          break
        case 'password2':
          if (!value) {
            return callback(new Error('確認密碼不可為空'))
          } else if (value !== this.rigisterData.password) {
            return callback(new Error('兩次密碼不一致，請重新輸入'))
          } else {
            callback()
          }
          break
        default:
          callback()
          break
      }
    }
    const checkFormChange = (rule, value, callback) => {
      const passwordRegex = /^\d{6}$/
      if (this.haveSendedRigister) {
        switch (rule.field) {
          case 'oldPassword':
            if (!value) {
              return callback(new Error('舊密碼不可為空'))
            } else if (value.length === 6 && !passwordRegex.test(value)) {
              return callback(new Error('密碼格式錯誤，請輸入6位數字'))
            } else {
              callback()
            }
            break
          case 'password':
            if (!value) {
              return callback(new Error('新密碼不可為空'))
            } else if (value.length === 6 && !passwordRegex.test(value)) {
              return callback(new Error('密碼格式錯誤，請輸入6位數字'))
            } else {
              callback()
            }
            break
          case 'password2':
            if (!value) {
              return callback(new Error('確認密碼不可為空'))
            } else if (value.length === 6 && value !== this.rigisterData.password) {
              return callback(new Error('兩次密碼不一致，請重新輸入'))
            } else {
              callback()
            }
            break
          default:
            callback()
            break
        }
      }
    }
    return {
      rigisterData: {
        oldPassword: '',
        password: '',
        password2: ''
      },
      rigisterRules: {
        oldPassword: [
          { validator: checkForm, trigger: 'blur' },
          { validator: checkFormChange, trigger: 'change' }
        ],
        password: [
          { validator: checkForm, trigger: 'blur' },
          { validator: checkFormChange, trigger: 'change' }
        ],
        password2: [
          { validator: checkForm, trigger: 'blur' },
          { validator: checkFormChange, trigger: 'change' }
        ]
      },
      haveSendedRigister: false,
      isSendingRigistration: false
    }
  },
  mounted () {
    setTimeout(() => {
      // eslint-disable-next-line eqeqeq
      if (document.getElementsByClassName('v-modal').length == 0) { // 解決登入過期時 alert 重複顯示的問題
        if (!JSON.parse(localStorage.getItem('loginStatus')) || !this.$getCookie('comLoginToken')) {
          this.$alert('登入過期或驗證失敗，請重新登入', '警告', {
            confirmButtonText: '確定',
            type: 'warning',
            showClose: false,
            roundButton: true,
            closeOnClickModal: false
          }).then(() => {
            this.$logoutCommunity()
          })
        }
        if (!JSON.parse(localStorage.getItem('loginUserInfo')).IsAuthorizationAccount) {
          this.$alert('沒有訪問權限', '警告', {
            confirmButtonText: '確定',
            type: 'warning',
            showClose: false,
            roundButton: true,
            closeOnClickModal: false
          }).then(() => {
            this.$router.back()
          })
          return false
        }
      }
    }, 500)
  },
  methods: {
    sendRigistration () {
      const vm = this
      vm.haveSendedRigister = true
      vm.$refs.changePasswordForm.validate((valid) => {
        if (valid && !vm.isSendingRigistration) {
          vm.isSendingRigistration = true
          const params = {
            OldPassword: vm.rigisterData.oldPassword,
            NewPassword: vm.rigisterData.password
          }
          apiManagement.PostPassword(params).then(res => {
            vm.$alert('變更密碼成功，請使用新密碼重新登入', '', {
              confirmButtonText: '確定',
              type: 'success',
              callback: action => {
                vm.$logoutCommunity()
              }
            })
          }).catch(err => {
            this.isSendingRigistration = false
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    filterValidValue (item) {
      const vm = this
      switch (item) {
        case 'oldPassword':
          vm.rigisterData.oldPassword = vm.rigisterData.oldPassword.replace(/[^0-9]/g, '')
          break
        case 'password':
          vm.rigisterData.password = vm.rigisterData.password.replace(/[^0-9]/g, '')
          break
        case 'password2':
          vm.rigisterData.password2 = vm.rigisterData.password2.replace(/[^0-9]/g, '')
          break
      }
    }
  }
}
</script>

<style lang="sass" scoped>
#changePassword
  padding-top: 40px
</style>
